import { render, staticRenderFns } from "./therapyEditTableScheme.vue?vue&type=template&id=1b7d32a4&scoped=true&"
import script from "./therapyEditTableScheme.vue?vue&type=script&lang=js&"
export * from "./therapyEditTableScheme.vue?vue&type=script&lang=js&"
import style0 from "./therapyEditTableScheme.vue?vue&type=style&index=0&lang=css&"
import style1 from "./therapyEditTableScheme.vue?vue&type=style&index=1&id=1b7d32a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7d32a4",
  null
  
)

export default component.exports